import {
  isElement,
  isText,
  getPluginType,
  getPluginOptions,
  getEmptyCellNode,
  insertElements,
  ELEMENT_TABLE,
} from '@udecode/plate';

import { getRowColCount } from './utils/getRowColCount';

export const withNormalizeMergableTable = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (isElement(node)) {
      if (node.type === getPluginType(editor, ELEMENT_TABLE)) {
        const { newCellChildren } = getPluginOptions(
          editor,
          ELEMENT_TABLE,
        );
        const [, colCount] = getRowColCount(node);

        node.children.forEach((row, index) => {
          const rowLength = Array.isArray(row.children) ? row.children.length : 0;
          // Validate and clean up row.
          if (rowLength === 1 && isText(row.children[0])) {
            // This row is going to get removed from other normalizing.
            return;
          }

          if (rowLength < colCount) {
            const colSpans = row.children.reduce((acc, col) => {
              if (col.colSpan && col.colSpan > 0) {
                return acc + parseInt(col.colSpan, 10);
              }
              return acc;
            }, 0);

            if (rowLength + colSpans < colCount) {
              const missingColCount = colCount - rowLength + colSpans;
              const emptyCell = getEmptyCellNode(editor, { header: false, ...newCellChildren });

              for (let i = 0; i < missingColCount; i += 1) {
                const rowPath = [...path, index, rowLength + i];
                insertElements(editor, emptyCell, { at: rowPath });
              }
            }
          }
        });
      }
    }

    return normalizeNode([node, path]);
  };

  return editor;
};
